import React, { Component } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

class SliderComponent extends Component {

    constructor(props) {

        super(props);
    
        this.state = {


             
        }

    }
    
    render() {

        const settings = {

            vertical: true,

            dots: false,

            autoplay: true,

            autoplaySpeed: 6000,

            infinite: true,

            speed: 500,

            slidesToShow: 1,

            slidesToScroll: 1,

            arrows: false,

            appendDots: dots => (

                <div

                    style={{

                        position: "absolute",

                        bottom: '10px',

                        borderRadius: "10px",

                        padding: "10px"

                    }}

                >

                  <ul style={{ margin: "0px" }}> {dots} </ul>

                </div>

            )

        };

        const { trending } = this.props;

        return (

            <div>

                <Slider {...settings}>
                    
                    {trending && trending.length > 0 && trending.map((single_trend, i) => <div key={i} className="h-72 min-h-[355px]">

                        <div className='flex flex-col relative h-full'>

                            <LazyLoadImage className='w-full object-cover h-full' src={single_trend.product[0].images[0]} alt={single_trend.product[0].name} />

                            <div className="absolute top-0 left-0 bg-black/20 flex flex-1 flex-col justify-end items-center w-full p-10 h-full space-y-4">

                                <h3 className="text-white text-3xl font-bold text-left w-full capitalize">{single_trend.product[0].name}</h3>

                                <h3 className="text-white text-xl font-bold text-left w-full">KES {single_trend.readable_moq_price}</h3>
                                <button
                                    className="bg-tangerine text-white text-base px-6 py-2 self-start"
                                    onClick={() => {
                                        (window.location.href = `/products/${single_trend.moq_slug}`)
                                    }}
                                >
                                    Place Your Order
                                </button>
                                

                            </div>

                        </div>

                    </div>)}

                    {!trending && <div className="h-72">

                        <div className="bg-litudian-orange rounded-md flex flex-1 flex-row justify-center items-center w-full p-10 h-full">

                            <h3 className="text-black text-4xl font-bold">Promo !</h3>

                        </div>
                        
                    </div>}
                    
                </Slider>
                
            </div>

        )

    }

};

export default SliderComponent;
